/**
 * @generated SignedSource<<7d964d9dc07dcd131bbd3283e4209867>>
 * @relayHash 2724a306ec7f11ae2e23b447526bceb2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2724a306ec7f11ae2e23b447526bceb2

import { ConcreteRequest } from 'relay-runtime';
export type TranscriptSpeaker = "AGENT" | "PATIENT";
export type CreateOrAppendCallTranscriptInput = {
  appointmentId: string;
  id?: string | null;
  progressNoteId: string;
  roomId?: string | null;
  transcript: ReadonlyArray<TranscriptEntryInput>;
  transcriptStartedAt: string;
};
export type TranscriptEntryInput = {
  id: string;
  isFinal: boolean;
  speaker: TranscriptSpeaker;
  text: string;
  timestamp: number;
};
export type useCreateOrAppendCallTranscriptMutation$variables = {
  input: CreateOrAppendCallTranscriptInput;
};
export type useCreateOrAppendCallTranscriptMutation$data = {
  readonly createOrAppendCallTranscript: {
    readonly callTranscript: {
      readonly appointmentId: string;
      readonly callTranscriptEndedAt: string;
      readonly callTranscriptStartedAt: string;
      readonly id: string;
      readonly progressNoteId: string;
      readonly roomId: string | null;
      readonly transcript: ReadonlyArray<{
        readonly id: string;
        readonly isFinal: boolean;
        readonly speaker: TranscriptSpeaker;
        readonly text: string;
        readonly timestamp: number;
      }>;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename?: string;
      readonly message?: string;
    }> | null;
  };
};
export type useCreateOrAppendCallTranscriptMutation = {
  response: useCreateOrAppendCallTranscriptMutation$data;
  variables: useCreateOrAppendCallTranscriptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CallTranscript",
  "kind": "LinkedField",
  "name": "callTranscript",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roomId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TranscriptEntry",
      "kind": "LinkedField",
      "name": "transcript",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFinal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "speaker",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callTranscriptStartedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callTranscriptEndedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateOrAppendCallTranscriptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateOrAppendCallTranscriptPayload",
        "kind": "LinkedField",
        "name": "createOrAppendCallTranscript",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCreateOrAppendCallTranscriptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateOrAppendCallTranscriptPayload",
        "kind": "LinkedField",
        "name": "createOrAppendCallTranscript",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*:: as any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2724a306ec7f11ae2e23b447526bceb2",
    "metadata": {},
    "name": "useCreateOrAppendCallTranscriptMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3820278f75fcb96a5cffa877ce1d89a0";

export default node;
